// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__1CbjF","button":"Tooltip_button__nuvOv","flex":"Tooltip_flex__1ksLY","icon":"Tooltip_icon__3KlgE"};